import { RootLayoutSiteinfoFragment } from '@business/gql/graphql';
import { Divider } from '@ngg/components';
import { cn } from '@ngg/storefront-utils';
import { ContentfulImage } from '@ui/components/Contentful';

type Props = {
  paymentLogos: RootLayoutSiteinfoFragment['paymentImagesCollection'];
  shippingLogos: RootLayoutSiteinfoFragment['shippingImagesCollection'];
};

export default function PaymentAndShippingLogos(props: Props) {
  const { paymentLogos, shippingLogos } = props;

  return (
    <div className="flex flex-row flex-wrap items-center justify-center gap-4 lg:shrink-0 lg:flex-nowrap lg:gap-3">
      {paymentLogos?.items?.map((logo) => {
        if (!logo?.image) return null;

        const imageRatio =
          (logo?.image?.width ?? 1) / (logo?.image?.height ?? 1);

        return (
          <div key={logo.sys.id}>
            <ContentfulImage
              desktopImage={logo.image}
              className={cn('h-6 w-auto', imageRatio > 2 && 'h-4')}
            />
          </div>
        );
      })}
      <Divider
        vertical
        className="mx-1 hidden w-[1px] border-borderColor py-4 sm:block"
      />
      {shippingLogos?.items?.map((logo) => {
        if (!logo?.image) return null;

        const imageRatio =
          (logo?.image?.width ?? 1) / (logo?.image?.height ?? 1);

        return (
          <div key={logo.sys.id}>
            <ContentfulImage
              desktopImage={logo.image}
              className={cn('h-6 w-auto', imageRatio > 2 && 'h-4')}
            />
          </div>
        );
      })}
    </div>
  );
}
